import React, { useEffect, useState } from "react";
import "./App.css";
import Sidebar from "./components/Sidebar/Sidebar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Users from "./components/Users/User";
import Dashboard from "./pages/Dashboard/Dashboard";
import { LoginForm } from "./pages/Login";
import { getToken } from "./utils/token";
import { ClientsPage } from "./pages/Clients";
import { ClientInfo } from "./pages/ClientInfo";
import { EditLeadPage, NewLeadPage, NewSpecification } from "./pages/NewLead";
import { ConfigProvider, Layout } from "antd";
import { ProductsPage } from "./pages/Products";
import { OrderStatusPage } from "./pages/OrderStatus";
import { UsersPage } from "./pages/Users";
import { CompanyPage } from "./pages/Company";
import ruRU from "antd/es/locale/ru_RU";
import { fetchUserPermission } from "./components/Sidebar/utils/fetch";
import { DateRangeProvider } from "./contexts/DateRangeContext";
import Supplies from "./pages/Supplies/Supplies";
import { EntityPage } from "./pages/KeplerEntity";
import { KeplerPartners } from "./pages/KeplerPartners";
import { AssemblyStatus } from "./pages/AssemblyStatus";
import { DeliveryStatus } from "./pages/DeliveryStatus";
import { ManufactureStatus } from "./pages/ManufactureStatus";
import InstallationStatus from "./pages/InstallationStatus/InstallationStatus";
import NPSPage from "./pages/NPS";
import DistributionPage from "./pages/Distribution/DistributionPage";
import HealthMonitor from "./pages/HealthMonitor";
import KeplerRob from "./pages/KeplerRob";
import NotificationsPage from "./pages/Notifications";
import MyFinances from "./pages/MyFinances";
import AuditLogPage from "./pages/KeplerRob/AuditLog";
function App() {
  const [token, setToken] = useState(getToken());
  const [userPermission, setUserPermission] = useState({});

  useEffect(() => {
    if (token) {
      fetchUserPermission(setUserPermission);
    }
  }, [token]);

  if (!token) {
    return <LoginForm setToken={setToken} />;
  }

  const getDefaultRoute = (userPermission) => {
    if (userPermission.manufactureStatus && !userPermission.orderStatus) {
      return <ManufactureStatus userPermission={userPermission} />
    }
    if (userPermission.assemblyStatus && !userPermission.orderStatus) {
      return <AssemblyStatus userPermission={userPermission} />
    }
    if (userPermission.installationStatus && !userPermission.orderStatus) {
      return <InstallationStatus userPermission={userPermission} />
    }
    if (userPermission.distribution && !userPermission.distribution) {
      return <DistributionPage userPermission={userPermission} />
    }
    if (userPermission.deliveryStatus && !userPermission.orderStatus) {
      return <DeliveryStatus userPermission={userPermission} />
    } else return <NewLeadPage />;
  };

  return (
    <ConfigProvider locale={ruRU}>
      <DateRangeProvider>
        <Router>
          <Layout>
            <Sidebar userPermission={userPermission} />
            <Layout
              style={{
                padding: 15,
                minHeight: "100vh",
                minWidth: 700,
              }}
            >
              <Routes>
                <Route path="/client">
                  <Route
                    path=":clientId"
                    element={
                      <ClientInfo
                        setToken={setToken}
                        userPermission={userPermission}
                      />
                    }
                  />
                  <Route index element={<ClientsPage />} />
                </Route>

                <Route path="/product" element={<ProductsPage setToken={setToken} />} />

                <Route path="/status">
                  <Route
                    index
                    element={<OrderStatusPage userPermission={userPermission} />}
                  />
                </Route>

                <Route path="/kepler-partner">
                  <Route index element={<KeplerPartners />} />
                </Route>

                <Route path="/lead">
                  <Route path=":clientId">
                    <Route path=":leadId">
                      <Route path=":applicationId">
                        <Route
                          path="edit"
                          element={<EditLeadPage setToken={setToken} />}
                        />
                      </Route>
                      <Route path="create" element={<NewSpecification />} />
                    </Route>
                    <Route index element={<NewLeadPage />} />
                  </Route>
                  <Route index element={<NewLeadPage />} />
                </Route>

                <Route path="/user">
                  <Route
                    path=":companyId"
                    element={
                      <UsersPage
                        setToken={setToken}
                        userPermission={userPermission}
                      />
                    }
                  />
                  <Route
                    index
                    element={
                      <CompanyPage
                        setToken={setToken}
                        userPermission={userPermission}
                      />
                    }
                  />
                </Route>

                <Route path="/supplies">
                  <Route index element={<Supplies />} />
                </Route>

                <Route path="/entity">
                  <Route index element={<EntityPage userPermission={userPermission} />} />
                </Route>

                <Route path="/assembly_status">
                  <Route index element={<AssemblyStatus userPermission={userPermission} />} />
                </Route>

                <Route path="/manufacture_status">
                  <Route index element={<ManufactureStatus userPermission={userPermission} />} />
                </Route>

                <Route path="/installation_status">
                  <Route index element={<InstallationStatus userPermission={userPermission} />} />
                </Route>

                <Route path="/delivery_status">
                  <Route index element={<DeliveryStatus userPermission={userPermission} />} />
                </Route>

                {/* Страница Distribution */}
                <Route
                  path="/distribution"
                  element={<DistributionPage userPermission={userPermission} />}
                />

                <Route path="/dashboard" element={<Dashboard userPermission={userPermission} />} />

                {/* Путь NPS */}
                <Route path="/nps" element={<NPSPage />} />

                {/* Путь HealthMonitor */}
                <Route path="/health-monitor" element={<HealthMonitor />} />

                {/* Kepler Sales Hub */}
                <Route path="/kepler-rob" element={<KeplerRob userPermission={userPermission} />} />

                {/* Kepler Sales Hub - Лог сверки данных */}
                <Route path="/kepler-rob/audit-log" element={<AuditLogPage userPermission={userPermission} />} />

                {/* Рассылка */}
                <Route path="/notifications" element={<NotificationsPage userPermission={userPermission} />} />

                {/* Мои финансы */}
                <Route path="/my-finances" element={<MyFinances userPermission={userPermission} />} />

                {/* Индексный маршрут: если не совпало ничего - делаем редирект или отображаем по умолчанию */}
                <Route index element={getDefaultRoute(userPermission)} />
              </Routes>
            </Layout>
          </Layout>
        </Router>
      </DateRangeProvider>
    </ConfigProvider>

  );
}

export default App;
